import React from 'react';
import ButtonWithGradient from './buttonWithGradient';
import withRequestCallModal from '../hocs/withRequestCallModal';

const GetConsultation = withRequestCallModal(props => (
  <ButtonWithGradient {...props} />
));

export default GetConsultation;